
import "./index.css";
import {Routes, Route} from 'react-router-dom';
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from "react-helmet-async";
import {NavBar, Footer} from "./components/pages/common";
import {Overview,Features,CETZone,CAPZone,Pricing,Dashboard,StudentDashboard,CandidateProfile} from './components/pages';
import { ContactUs } from "./components/pages/ContactUs";
import { LandingPage  } from "./components/pages/Landing";
import {ForumPage,ForumQueryRepliesPage } from "./components/pages/community";
import {CandidateLogin, CandidateRegistration, ActivateAccount, ResendActivateLink, VerifyEmailChange, ResetPasswordPage} from "./components/Authentication";
import { PrivacyStatement, TermsConditions } from "./components/pages/Footer/PrivacyStatement";
import { UserProvider } from "./components/store/UserContext";
import PredictionPage from "components/pages/collegepredictor/predictionpage";


function App() {
  // src/components/pages/NotFound.jsx
  const NotFound = () => {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h1>404 - Page Not Found</h1>
        <p>You’ve entered the void. Nothing lives here. 🕳️</p>
      </div>
    );
  };

  return (
    <QueryClientProvider client={queryClient}>
      <UserProvider>
        <div className="flex flex-col max-h-100vh">
          <NavBar />
          <HelmetProvider>
            <Routes className="flex-grow">
              <Route path="/" element={<LandingPage />} />
              <Route path="/overview" element={<Overview />} />
              <Route path="/features" element={<Features />} />
              <Route path="/student-dashboard" element={<StudentDashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/cetzone" element={<CETZone />} />
              <Route path="/cetzone/exam-dates" element={<CETZone />} />
              <Route path="/cetzone/exam-notices" element={<CETZone />} />
              <Route path="/capzone" element={<CAPZone />} />
              <Route path="/capzone/" element={<CAPZone />} />
              <Route path="/capzone/nirf-rankings" element={<CAPZone />} />
              <Route path="/capzone/caps-dates" element={<CAPZone />} />
              <Route path="/capzone/caps-notices" element={<CAPZone />} />
              <Route path="/capzone/seat-matrix" element={<CAPZone />} />
              <Route path="/capzone/rank-cutoffs" element={<CAPZone />} />
              <Route path="/prediction" element={<PredictionPage/>} />
              <Route path="/community" element={<ForumPage />} />
              <Route path="/forumqueryreplies/:id" element={<ForumQueryRepliesPage />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/contactus" element={<ContactUs />} />
              <Route path="/login" element={<CandidateLogin />} />
              <Route path="/register" element={<CandidateRegistration />} />
              <Route path="/PrivacyStatement" element={<PrivacyStatement />} />
              <Route path="/TermsConditions" element={<TermsConditions />} />
              <Route path="/reset-password/:uid/:token" element={<ResetPasswordPage />} />
              <Route path="/activate/:uid/:token/" element={<ActivateAccount />} />
              <Route path="/resend-activate" element={<ResendActivateLink />} />
              <Route path="/verify-email-change" element={<VerifyEmailChange />} />
              <Route path="/candidate-profile" element={<CandidateProfile />} />

              <Route path="*" element={<NotFound/>} />
              
            </Routes>
          </HelmetProvider>
      {/* populating context arrays with master data*/}
          <div className="p-4">
            <Footer />
          </div>
        </div>
      </UserProvider>
    </QueryClientProvider>
  );
}

export default App;
